import JackpotTickerRedux from './jackpot_ticker_redux';

export default JackpotTickerRedux;
